import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export const LinkIcon = createIcon({
  viewBox: '0 0 16 24',
  defaultProps: {
    fill: palette.primary.main,
  },
  path: (
    <>
      <g filter="url(#HeadingDividerLinkIcon)">
        <path
          fill="fill"
          d="M13.04 13.7 3.9 23.3a2.22 2.22 0 0 1-3.23 0c-.9-.94-.9-2.46 0-3.4L8.2 12 .67 4.1c-.9-.94-.9-2.46 0-3.4A2.2 2.2 0 0 1 3.9.7l9.14 9.6c.9.94.9 2.46 0 3.4Z"
        />
      </g>
      <defs>
        <filter
          id="HeadingDividerLinkIcon"
          width="15.71"
          height="24"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.941176 0 0 0 0 0.866667 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1515_400" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1515_400" result="shape" />
        </filter>
      </defs>
    </>
  ),
});
